export const ENEMIES = [
  {
    id: 1,
    name: 'enemy 1',
    maxHp: 300,
    maxCount: 2,
    attack: 30,
  },
  {
    id: 2,
    name: 'enemy 2',
    maxHp: 500,
    maxCount: 3,
    attack: 90,
  },
  {
    id: 3,
    name: 'enemy 3',
    maxHp: 900,
    maxCount: 5,
    attack: 150,
  },
];

export const QUIZZES = [
  {
    quiz: '5 + 5 = ?',
    options: [
      {
        id: 1,
        text: '10',
      },
      {
        id: 2,
        text: '15',
      },
      {
        id: 3,
        text: '20',
      },
      {
        id: 4,
        text: '25',
      },
    ],
  },
  {
    quiz: '15 + 5 = ?',
    options: [
      {
        id: 1,
        text: '20',
      },
      {
        id: 3,
        text: '10',
      },
      {
        id: 2,
        text: '15',
      },
      {
        id: 4,
        text: '25',
      },
    ],
  },
  {
    quiz: '15 + 10 = ?',
    options: [
      {
        id: 1,
        text: '25',
      },
      {
        id: 2,
        text: '15',
      },
      {
        id: 3,
        text: '20',
      },
      {
        id: 4,
        text: '10',
      },
    ],
  },
];

export const FRIENDS = [
  {
    id: 1,
    name: 'friend 1',
    maxHp: 300,
    attack: 30,
  },
  {
    id: 2,
    name: 'friend 2',
    maxHp: 500,
    attack: 50,
  },
  // {
  //   id: 3,
  //   name: 'friend 3',
  //   maxHp: 200,
  //   attack: 70,
  // },
  // {
  //   id: 4,
  //   name: 'friend 4',
  //   maxHp: 200,
  //   attack: 40,
  // },
  // {
  //   id: 5,
  //   name: 'friend 5',
  //   maxHp: 200,
  //   attack: 40,
  // },
  // {
  //   id: 6,
  //   name: 'friend 6',
  //   maxHp: 200,
  //   attack: 40,
  // },
];
